import React from "react";
import { Link } from "react-router-dom";
import { profile } from "../../data/site";
import Reveal from "../chrome/Reveal";
import { ArrowRight, Download } from "../../lib/icons";

const Cta = ({
  title = "Have something you need built?",
  lede = "Roles, contract work, or a problem you want a second pair of eyes on — tell me what you're working on.",
}) => (
  <section className="section">
    <div className="shell">
      <Reveal className="cta">
        <h2 className="cta__title">{title}</h2>
        <p className="cta__lede">{lede}</p>
        <div className="cta__actions">
          <Link className="btn btn--primary" to="/contact">
            Start a conversation <ArrowRight size={17} />
          </Link>
          <a className="btn btn--ghost" href={profile.resume} target="_blank" rel="noopener noreferrer">
            <Download size={17} /> Download résumé
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Cta;
